export class ReportingParams {
  clientNumber: string | null;
  currency: string = "MUR";
  reportType: string;
  reportFolder: string;
  portfolioIds: number[] | null = [];
  saveToS3: boolean = false;
  userId: number | null;
  fromDate: string;
  toDate: string;
  displayLocalPerformance: boolean = true;
  displayInternationalPerformance: boolean = true;
  displayMonthlyPerformance: boolean = false;
  displayLineItems: boolean = true;
  isReconciled: boolean = false;
  inceptionPerf: boolean = false;
  trailingTwelveMonthsPerf: boolean = false;
  financialYearToDatePerf: boolean = false;
  currencySplit: boolean = false;
  topCombinedHoldings: boolean = false;
  topCombinedEquityHoldings: boolean = false;
  topCombinedFixedIncomeHoldings: boolean = false;
  topLocalHoldings: boolean = false;
  topLocalEquityHoldings: boolean = false;
  topLocalFixedIncomeHoldings: boolean = false;
  topInternationalHoldings: boolean = false;
  topInternationalEquityHoldings: boolean = false;
  topInternationalFixedIncomeHoldings: boolean = false;

  // Benchmark columns
  combinedBenchmark: boolean = false;
  localBenchmark: boolean = false;
  internationalBenchmark: boolean = false;
  combinedBenchmarkPrimary: boolean = false;
  combinedBenchmarkSecondary: boolean = false;
  localBenchmarkPrimary: boolean = false;
  localBenchmarkSecondary: boolean = false;
  internationalBenchmarkPrimary: boolean = false;
  internationalBenchmarkSecondary: boolean = false;
  // End Benchmark columns
  strategyGoingForward: boolean = false;
  lastTransaction: boolean = false;
  portfolioAttribution: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/reporting/reportingParams.ts